export default {
    data: () => ({
        translations: {
            addBrand: {
                el: "Προσθήκη Συνεργάτη",
                en: "Add Collaborator",
                it: "Aggiungi Collaboratore"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            addNewCollaborator: {
                el: "Προσθήκη νέου Συνεργάτη",
                en: "Add new collaborator",
                it: "Aggiungi Collaboratore"
            },
            chooseCollaborator: {
                el: "Επιλέξτε Συνεργάτη",
                en: "Choose a collaborator",
                it: "Scegliere un Collaboratore"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            fromCompany: {
                el: "Aπό την εταιρία",
                en: "From Company",
                it: "Dall'azienda"
            },
            toCompany: {
                el: "Προς την εταιρία",
                en: "To Company",
                it: "All'azienda"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Stato"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            enable: {
                el: "Ενεργοποίηση",
                en: "Enable",
                it: "Abilitare"
            },
            disable: {
                el: "Απνεργοποίηση",
                en: "Disable",
                it: "Disattivare"
            },
            resend: {
                el: "Επαναποστολή",
                en: "Resend",
                it: "Rispedisci"
            },
            accept: {
                el: "Αποδοχή",
                en: "Accept",
                it: "Accettare"
            },
            active: {
                el: "Ενεργή",
                en: "Active",
                it: "Attivo"
            },
            inactive: {
                el: "Ανενεργή ",
                en: "Inactive",
                it: "Inattivo"
            },
            pending: {
                el: "Σε εκκρεμότητα",
                en: "Pending",
                it: "In attesa"
            },
        }
    })
};
